<template>
  <b-card>
    <table class="table table-hover">
      <thead>
        <tr>
          <th>Numer wpisu</th>

          <th>Kod</th>
          
          <th>Rodzaj nieobecności</th>
          
          <th>Czy liczyć weekendy?</th>

          <th>Ukryte</th>

          <th>Czy wyświetlać na podsumowaniu?</th>

          <th>Czy urlop?</th>
          
          <th width="100px">
            <b-btn size="sm" variant="outline-secondary" class="float-right" @click="showAddAbsenceModal">Dodaj</b-btn>
          </th>
        </tr>
      </thead>
      
      <tbody>
        <tr v-for="item in absences" :key="item.id">
          <td>{{ item.id }}</td>
          
          <td>{{ item.code }}</td>
          
          <td>{{ item.name }}</td>
          
          <td><display-boolean :value="item.isWorktime"></display-boolean></td>

          <td><display-boolean :value="item.displayAsWorktime"></display-boolean></td>
          
          <td><display-boolean :value="item.isPaid"></display-boolean></td>

          <td><display-boolean :value="item.isHoliday"></display-boolean></td>
          
          <td class="text-right">
            <b-btn
              size="sm"
              class="mr-2"
              @click="selectedItem = item; modalShow = true;"
              variant="outline-primary"
            >
              <font-awesome-icon icon="edit"></font-awesome-icon>
            </b-btn>

            <b-btn size="sm" @click="removeAbsence(item.id)" variant="outline-danger">
              <font-awesome-icon icon="trash-alt"></font-awesome-icon>
            </b-btn>
          </td>
        </tr>
      </tbody>
    </table>

    <modal v-if="modalShow" :addModal="modalShow" :item="selectedItem" @cancel="hideModal" @add="itemAdded" @edited="itemEdited"></modal>
  </b-card>
</template>

<script>
import DisplayBoolean from '@/components/DisplayBoolean.vue';
import { AbsenceResource } from '@/resources/absence.resource';

import modal from './modal.vue';

export default {
  components: { modal, DisplayBoolean },
  data() {
    return {
      absences: [],
      modalShow: false,
      selectedItem: null
    };
  },
  methods: {
    // Pobiera listę
    getAbsence() {
      AbsenceResource.list(['code', 'isWorktime', 'displayAsWorktime', 'isPaid', 'isHoliday'])
        .then(absences => this.$set(this, 'absences', absences))
        .catch(error => {
          this.$notify({ type: 'error', text: 'Wystąpił błąd pobierania danych', title: 'Błąd' });
          console.warn(error);
        });
    },
    // Usuwa
    removeAbsence(id) {
      if (!confirm('Czy na pewno usunąć?')) {
        return;
      }
      AbsenceResource.delete(id)
        .then(() => {
          this.absences.splice(this.absences.findIndex(absence => absence.id === id), 1);
          this.$notify({ type: 'success', title: 'Sukces', text: 'Pomyślnie usunięto' });
        })
        .catch(error => {
          this.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas usuwania' });
          console.warn(error);
        });
    },
    // Otwiera modal
    showAddAbsenceModal() {
      this.modalShow = true;
    },
    // Zamyka modal
    hideModal() {
      this.modalShow = false;
      this.selectedItem = null;
    },
    // Dodaje obiekt do listy
    itemAdded(item) {
      this.hideModal();
      this.absences.push(item);
    },
    // Aktualizuje obiekt na liście
    itemEdited(item) {
      this.hideModal();
      this.$set(this.absences, this.absences.findIndex(absence => absence.id === item.id), item);
    }
  },
  mounted() {
    this.getAbsence();
  }
};
</script>
